function request(url, maxCount = 5) {
  return new Promise((resolve, reject) => {

      fetch(url).then(res => {
        if (res.status === 429 || !res.ok) {
          maxCount <= 0 ? reject(res) : setTimeout(() => {
            request(url, maxCount - 1).then(r => {
              resolve(r)
            }).catch(e => {
              reject(e)
            })
          }, 2000)
        } else {
          resolve(res)
        }

      }).catch(err => {
        maxCount <= 0 ? reject(err) : setTimeout(() => {
          request(url, maxCount - 1).then(r => {
            resolve(r)
          }).catch(e => {
            reject(e)
          })
        }, 2000)
      });

  })
}


export default request;